export default __webpack_public_path__ + "img/eaba7076e4eaed28b2ecc4def8347719.svg";